<template>
  <div ref="tab_panel" class="tab__panel">
    <el-tabs
      v-model="activeIdTab"
      @tab-click="tabClick($event)"
      :key="updateKey"
      :addable="addButton"
      @tab-add="$emit('addTab')"
      @tab-remove="$emit('removeTab', getActiveTab)"
      :before-leave="beforeLeave"
      :class="[
        'tabs',
        'big',
        shadowTabs ? 'tabs--shadow' : '',
        shortTabs ? 'tabs--short' : ''
      ]"
    >
      <el-tab-pane
        v-for="(tab, i) in tabs"
        :key="`${i}_${tab.id}_${tab.name}`"
        :name="tab.id"
        :closable="tab.id == activeIdTab && closable"
        :disabled="tab.disabled"
        :class="[
          'tab',
          tab.id == 'candidates' ||
          tab.id == 'responds' ||
          tab.id == 'respondsTable'
            ? 'tab-candidate'
            : ''
        ]"
      >
        <span slot="label" class="label">
          <div class="tab-label">
            <Picture
              v-if="tab.icon"
              :url="tab.icon"
              width="24"
              height="24"
              class="tab-label__img"
            />
            <p ref="tab-text" class="tab-label__text">
              {{ setTabNameText(tab) }}
            </p>
          </div>
        </span>

        <div
          v-if="
            loading ||
            (getActiveTab.id === 'communications' &&
              !Object.keys(communicationParams).length)
          "
          class="tab__loading"
        >
          <Loader size="large"></Loader>
        </div>

        <AssessmentTab
          v-if="
            getActiveTab.id === 'checklist' &&
            tab.id === 'checklist' &&
            getActiveTabData &&
            getActiveTabData[getActiveTab.id] &&
            getActiveTabData[getActiveTab.id].metadata &&
            !loading
          "
          :metadata="getActiveTabData[getActiveTab.id]"
          @reloadTab="reloadTab"
        ></AssessmentTab>

        <RespondsTab
          v-if="
            getActiveTab.id === 'responds' &&
            tab.id === 'responds' &&
            getActiveTabData[getActiveTab.id] &&
            getActiveTabData[getActiveTab.id].data &&
            !loading
          "
        ></RespondsTab>

        <RespondsTableTab
          v-if="
            getActiveTab.id === 'respondsTable' &&
            tab.id === 'respondsTable' &&
            getActiveTabData[getActiveTab.id] &&
            !loading
          "
          :data="getActiveTabData[getActiveTab.id]"
        ></RespondsTableTab>

        <EventTab
          v-if="
            getActiveTab.id === 'events' &&
            tab.id === 'events' &&
            getActiveTabData &&
            getActiveTabData[getActiveTab.id] &&
            getActiveTabData[getActiveTab.id].data &&
            !loading
          "
          :metadata="getActiveTabData[getActiveTab.id]"
          @reloadTab="reloadTab"
          @set-loading="val => tabLoading(val)"
        />
        <VacanciesTab
          v-if="
            getActiveTab.id === 'vacancy' &&
            tab.id === 'vacancy' &&
            getActiveTabData &&
            getActiveTabData[getActiveTab.id] &&
            !loading
          "
          :metadata="getActiveTabData"
          @set-loading="val => tabLoading(val)"
        />
        <QuestionnairesTab
          v-if="
            getActiveTab.id === 'candidate_questionnaire' &&
            tab.id === 'candidate_questionnaire' &&
            getActiveTabData &&
            getActiveTabData[getActiveTab.id] &&
            getActiveTabData[getActiveTab.id].data &&
            !loading
          "
          :metadata="getActiveTabData[getActiveTab.id]"
          @reloadTab="reloadTab"
          @set-loading="val => tabLoading(val)"
        />
        <DocumentTab
          v-if="
            getActiveTab.id === 'documents' &&
            tab.id === 'documents' &&
            !loading &&
            getActiveTabData
          "
          :module="
            getActiveTab.intents &&
            getActiveTab.intents.length &&
            getActiveTab.intents[0].module
              ? getActiveTab.intents[0].module
              : module
          "
          :metadata="getActiveTabData[getActiveTab.id]"
          :id="
            getActiveTab.intents &&
            getActiveTab.intents.length &&
            getActiveTab.intents[0].request &&
            getActiveTab.intents[0].request.request_params &&
            getActiveTab.intents[0].request.request_params.record
              ? getActiveTab.intents[0].request.request_params.record
              : $route.params.id
          "
          :tabData="tab"
          @reloadTab="reloadTab"
          @set-loading="tabLoading"
        />
        <HistoryTab
          v-if="
            getActiveTab.id === 'audit' &&
            tab.id === 'audit' &&
            getActiveTabData[getActiveTab.id] &&
            !loading
          "
          :module="module"
          :tab-id="tab.id"
        />
        <description-tab
          v-if="
            ((getActiveTab.id === 'description' && tab.id === 'description') ||
              (getActiveTab.id === 'dynamic_coordination_subpanel' &&
                tab.id === 'dynamic_coordination_subpanel' &&
                getActiveTab.type === 'HRPAC_COORDINATION_REQUESTS')) &&
            getActiveTabData[getActiveTab.id] &&
            !loading
          "
          :fields="tab.fields_arr"
          @reloadTab="reloadTab"
          :metadata="getActiveTabData[getActiveTab.id].metadata"
        ></description-tab>
        <offer-tab
          v-if="
            getActiveTab.id === 'dynamic_coordination_subpanel' &&
            tab.id === 'dynamic_coordination_subpanel' &&
            getActiveTab.type === 'HRPAC_OFFERS' &&
            getActiveTabData[getActiveTab.id] &&
            !loading
          "
        />
        <application-stages-tab
          v-if="getActiveTab.id === 'plan' && tab.id === 'plan' && !loading"
          :user-id="$route.params.id"
          :id="candidateId"
          :module="module"
          @set-loading="val => tabLoading(val)"
        ></application-stages-tab>
        <communication-tab
          v-if="
            getActiveTab.id === 'communications' &&
            tab.id === 'communications' &&
            !loading &&
            Object.keys(communicationParams).length
          "
          :tab="tab"
          :id="candidateId"
          :table-sql="tabSubpanel(tab)"
          :user-id="userId"
          :module="module"
          :allowed-scroll="true"
          :params="communicationParams"
          @set-loading="val => tabLoading(val)"
        ></communication-tab>
        <comment-tab
          v-if="
            getActiveTab.id === 'comments' &&
            tab.id === 'comments' &&
            getActiveTabData[getActiveTab.id]
          "
          mode="subpanels"
          :user-id="userId"
          :id="candidateId"
          :loading="loading"
          :module="module"
          :table-sql="tabSubpanel(tab)"
          @set-loading="val => tabLoading(val)"
        ></comment-tab>

        <vacancy-steps
          v-if="
            getActiveTab.id === 'selection' &&
            tab.id === 'selection' &&
            !loading
          "
          @set-loading="val => tabLoading(val)"
        />
        <publicator-tab
          v-if="
            getActiveTab.id === 'publicator' &&
            tab.id === 'publicator' &&
            !loading
          "
          :module="module"
          :id="$route.params.id"
          @reloadTab="reloadTab"
          @set-loading="val => tabLoading(val)"
        />
        <ResumeEditTab
          v-if="
            getActiveTab.type === 'candidates_resume' &&
            tab.id !== 'resume' &&
            tab.id == getActiveTab.id &&
            getActiveTabData &&
            getActiveTabData[getActiveTab.id] &&
            getActiveTabData[getActiveTab.id].metadata &&
            !loading
          "
          :candidateId="candidateId"
          :id="tab.id"
          :fields="getActiveTabData[getActiveTab.id].bean"
          :metaData="getActiveTabData[getActiveTab.id].metadata"
        />
        <ResumeListTab
          v-if="
            getActiveTab.type === 'resumes_list' &&
            tab.id == 'resumes_list' &&
            tab.id == getActiveTab.id &&
            getActiveTabData &&
            getActiveTabData[getActiveTab.id] &&
            getActiveTabData[getActiveTab.id].metadata &&
            !loading
          "
          :metaData="
            Array.isArray(getActiveTabData[getActiveTab.id].metadata)
              ? {}
              : getActiveTabData[getActiveTab.id].metadata
          "
        />
        <resume-tab
          v-if="
            ((tab.id == getActiveTab.id && getActiveTab.type == 'resume') ||
              (getActiveTab.id === 'dynamic_coordination_subpanel' &&
                tab.id === 'dynamic_coordination_subpanel' &&
                getActiveTab.type === 'HRPAC_CANDIDATES_RESUME')) &&
            getActiveTabData &&
            getActiveTabData[getActiveTab.id] &&
            getActiveTabData[getActiveTab.id].length &&
            !loading
          "
          :id="getActiveTab.id"
        ></resume-tab>
        <candidates-tab
          v-if="
            getActiveTab.id === 'candidates' &&
            tab.id === 'candidates' &&
            getActiveTabData[getActiveTab.id] &&
            getActiveTabData[getActiveTab.id].data &&
            !loading
          "
        />
        <doubles-tab
          v-if="getActiveTab.id === 'duplicates' && tab.id === 'duplicates'"
          :tabs="getActiveTab?.subpanel_collection"
        />
        <doubles-sub-tab
          v-if="
            getActiveTab.id === 'mark_as_diff_duplicates' &&
            tab.id === 'mark_as_diff_duplicates' &&
            getActiveTabData[getActiveTab.id] &&
            getActiveTabData[getActiveTab.id].data &&
            !loading
          "
        />
        <doubles-sub-tab
          v-if="
            getActiveTab.id === 'found_duplicates' &&
            tab.id === 'found_duplicates' &&
            getActiveTabData[getActiveTab.id] &&
            getActiveTabData[getActiveTab.id].data &&
            !loading
          "
        />
        <role-tab
          v-if="
            getActiveTab.id === 'user_roles' &&
            tab.id === 'user_roles' &&
            getActiveTabData[getActiveTab.id] &&
            getActiveTabData[getActiveTab.id].data &&
            !loading
          "
        />
        <vacancies-list-tab
          v-if="
            getActiveTab.id === 'vacancies' &&
            tab.id === 'vacancies' &&
            getActiveTabData[getActiveTab.id] &&
            getActiveTabData[getActiveTab.id].data &&
            !loading
          "
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { eventBus } from '@/bus';
import { getController } from '@/controllers/request.js';
import { store } from '@/store';
import { EVENTBUS_EVENTS, MODULE } from '@/utils/constants';
import Loader from 'Elements/Loader/Loader';
import Picture from 'Elements/Picture/Picture';
import ApplicationStagesTab from 'Elements/Tab/ApplicationStagesTab';
import AssessmentTab from 'Elements/Tab/AssessmentTab';
import CandidatesTab from 'Elements/Tab/CandidatesTab';
import CommentTab from 'Elements/Tab/CommentTab';
import CommunicationTab from 'Elements/Tab/CommunicationTab';
import DescriptionTab from 'Elements/Tab/DescriptionTab';
import DocumentTab from 'Elements/Tab/DocumentTab';
import DoublesTab from 'Elements/Tab/DoublesTab';
import EventTab from 'Elements/Tab/EventTab';
import HistoryTab from 'Elements/Tab/HistoryTab';
import OfferTab from 'Elements/Tab/OfferTab.vue';
import PublicatorTab from 'Elements/Tab/PublicatorTab';
import QuestionnairesTab from 'Elements/Tab/QuestionnairesTab';
import RespondsTab from 'Elements/Tab/RespondsTab';
import RespondsTableTab from 'Elements/Tab/RespondsTableTab';
import ResumeEditTab from 'Elements/Tab/ResumeEditTab';
import ResumeListTab from 'Elements/Tab/ResumeListTab';
import ResumeTab from 'Elements/Tab/ResumeTab';
import VacanciesListTab from 'Elements/Tab/VacanciesListTab.vue';
import VacanciesTab from 'Elements/Tab/VacanciesTab';
import VacancySteps from 'Elements/Tab/VacancySteps';
import { TabPane, Tabs } from 'element-ui';
import DoublesSubTab from '../Tab/DoublesSubTab.vue';
import RoleTab from '../Tab/RoleTab.vue';

export default {
  props: {
    tabs: {
      type: Array,
      default() {
        return [];
      }
    },
    shadowTabs: {
      type: Boolean,
      default: false
    },
    shortTabs: {
      type: Boolean,
      default: false
    },
    destroyBuses: {
      type: Boolean,
      default: true
    },
    module: String,
    closable: {
      type: Boolean,
      default: false
    },
    addButton: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    succesSave: {
      type: Boolean,
      default: true
    }
  },
  created() {
    setTimeout(() => {
      let tabPanel = this.$refs.tab_panel;
      const resizeObserver = new ResizeObserver(this.handleResize);
      if (tabPanel) {
        resizeObserver.observe(tabPanel);
        let tabsWrap = tabPanel.getElementsByClassName(
          'el-tabs__nav-scroll'
        )[0];
        //событие прокрутки сабпанели при помощи колёсика мыши
        tabsWrap.addEventListener('wheel', this.initMouseWheel);
      }
    }, 0);
    this.clearCacheTabs();
    store.commit('subpanels/setActiveSubpanel', {
      module: this.module,
      activeSubpanel:
        this.module == 'RightPanel' &&
        store.state.rightPanel.metadata.type == 'vac_card_selcand'
          ? this.tabs[1]
          : this.tabs[0]
    });

    if (
      this.getActiveTab.id != 'vacancy' &&
      this.getActiveTab.id != 'candidate'
    ) {
      if (store.state.candidate.changeableVacCandList.changeable) {
        store.commit('candidate/setChangeableVacCandListVisible');
      }
      store.dispatch('subpanels/getDataForTab', {
        module: this.module,
        tab: this.getActiveTab
      });
    }

    if (this.getActiveTab.type != 'candidates_resume') {
      this.reloadTabCheck = false;
    }

    store.dispatch('common/getUserData');

    if (this.module !== MODULE.VACANCY_MODULE) {
      // наличие сообщений в Коммуникациях
      this.checkCommunication();
    }

    if (
      this.module == 'RightPanel' &&
      store.state.rightPanel.metadata.type == 'vac_card_selvac' &&
      store.state.vacancy.currentVacancyCandidate &&
      !store.state.rightPanel.candidateTabOnceOpened
    ) {
      this.tabClick({ index: 1, id: 'candidate' });
      store.commit('rightPanel/setParam', {
        name: 'candidateTabOnceOpened',
        val: true
      });
    }

    eventBus.$on(EVENTBUS_EVENTS.RELOAD_TAB, (tabId, type) => {
      if (this.activeIdTab == tabId && type != 'candidates_resume') {
        this.clearCacheTabs();
        this.reloadTab();
      } else if (type == 'candidates_resume') {
        store.commit('subpanels/setActiveSubpanel', {
          module: this.module,
          activeSubpanel: this.tabs.find(tab => tab.id == tabId)
        });

        store.dispatch('subpanels/getDataForTab', {
          module: this.module,
          tab: this.tabs.find(tab => tab.id == tabId)
        });

        this.activeIdTab = tabId;
        this.reloadTabCheck = false;
      }
    });

    if (
      this.$router.currentRoute.name === 'commentId' ||
      this.$router.currentRoute.name === 'commentIdVacancy' ||
      this.$router.currentRoute.name === 'commentIdCoordination' ||
      this.$router.currentRoute.name === 'commentIdCoordinationRequest'
    ) {
      this.changeTabSubpanel('comments');
    }

    eventBus.$on(EVENTBUS_EVENTS.UPDATE_SUBPANEL_LABELS, this.updateLabels);
  },
  beforeDestroy() {
    if (this.destroyBuses) {
      eventBus.$off(EVENTBUS_EVENTS.RELOAD_TAB);
    }
    eventBus.$off(EVENTBUS_EVENTS.UPDATE_SUBPANEL_LABELS, this.updateLabels);
    this.clearCacheTabs();
  },
  data() {
    return {
      activeIdTab:
        this.module == 'RightPanel' &&
        store.state.rightPanel.metadata.type == 'vac_card_selcand'
          ? this.tabs[1].id
          : this.tabs[0].id,
      tabsNeedScroll: false,
      enabledLeftScroll: false,
      leftScrolling: false,
      rightScrolling: false,
      enabledRightScroll: false,
      updateKey: 0,
      communicationParams: {},
      reloadTabCheck: true,
      speedScroll: 150,
      minSpeedScroll: 50
    };
  },
  computed: {
    filtersData() {
      return store.state.filters.filterConfig;
    },
    loading() {
      return store.state.subpanels.loading &&
        store.state.subpanels.loading[this.module]
        ? store.state.subpanels.loading[this.module]
        : false;
    },
    userId() {
      return store.state.common.userId || '';
    },
    getActiveTabData() {
      return store.state.subpanels.activeSubpanelData;
    },
    getActiveTab() {
      return store.state.subpanels.activeSubpanel[this.module];
    },
    candidateId() {
      return this.module === MODULE.VACANCY_MODULE
        ? this.$router.history?.current?.params?.id
        : this.module === MODULE.CANDIDATES_MODULE &&
          store?.state?.vacancy?.currentVacancyCandidate?.ID &&
          this.$router.history?.current?.meta?.module === MODULE.VACANCY_MODULE
        ? store?.state?.vacancy?.currentVacancyCandidate?.ID
        : this.module === MODULE.CANDIDATES_MODULE &&
          this.$router.history?.current?.meta?.module ===
            MODULE.CANDIDATES_MODULE &&
          store?.state?.candidate?.currentCandidate?.ID
        ? store?.state?.candidate?.currentCandidate?.ID
        : this.$route?.params?.id
        ? this.$route.params.id
        : '' || this.id;
    }
  },
  watch: {
    leftScrolling() {
      this.scrollLeft();
    },
    rightScrolling() {
      this.scrollRight();
    }
  },
  methods: {
    changeTabSubpanel(tab) {
      // Находим индекс таба который нам нужен и кликаем по нему
      const enemyTab = this.tabs.findIndex(item => item.id === tab);
      this.tabClick({ index: enemyTab, id: tab });
    },

    initMouseWheel(e) {
      const tabsWrap = this.$refs.tab_panel.getElementsByClassName(
        'el-tabs__nav-scroll'
      )[0];
      const rightScrollArea =
        this.$refs.tab_panel.getElementsByClassName('el-tabs__nav-next')[0];
      const leftScrollArea =
        this.$refs.tab_panel.getElementsByClassName('el-tabs__nav-prev')[0];
      e.preventDefault();
      e.stopPropagation();
      //если колёсико мыши прокручено вверх и зона с правой стрелкой скрыта
      //то показываем её
      if (
        leftScrollArea &&
        e.wheelDelta < 0 &&
        Array.from(leftScrollArea.classList).includes('is-disabled')
      ) {
        leftScrollArea.classList.remove('is-disabled');
      }
      //если колёсико мыши прокручено вверх и прокручено до упора
      //то скрываем зону с левой стрелкой
      else if (
        rightScrollArea &&
        e.wheelDelta < 0 &&
        (Math.floor(tabsWrap.scrollLeft + this.speedScroll * 2) + 2 >=
          tabsWrap.scrollWidth - tabsWrap.parentNode.offsetWidth ||
          Math.floor(tabsWrap.scrollLeft + this.speedScroll * 2) + 1 >=
            tabsWrap.scrollWidth - tabsWrap.parentNode.offsetWidth ||
          Math.floor(tabsWrap.scrollLeft + this.speedScroll * 2) >=
            tabsWrap.scrollWidth - tabsWrap.parentNode.offsetWidth)
      ) {
        rightScrollArea.classList.add('is-disabled');
      }
      //если колёсико мыши прокручено вниз и зона с левой кнопкой скрыта
      //то показываем её
      else if (
        rightScrollArea &&
        e.wheelDelta > 0 &&
        Array.from(rightScrollArea.classList).includes('is-disabled')
      ) {
        rightScrollArea.classList.remove('is-disabled');
      }
      //если колёсико мыши прокручено вниз и прокручено до упора
      //то скрываем зону с правой стрелкой
      else if (
        leftScrollArea &&
        e.wheelDelta > 0 &&
        tabsWrap.scrollLeft - this.speedScroll * 2 <= 0
      ) {
        leftScrollArea.classList.add('is-disabled');
      }
      tabsWrap.scrollTo({
        left:
          e.wheelDelta < 0
            ? tabsWrap.scrollLeft + this.speedScroll * 2
            : tabsWrap.scrollLeft - this.speedScroll * 2,
        behavior: 'smooth'
      });
    },
    scrollLeft() {
      let scrolling = null;
      if (this.leftScrolling) {
        let tabsWrap = this.$refs.tab_panel.getElementsByClassName(
          'el-tabs__nav-scroll'
        )[0];
        const rightScrollArea =
          this.$refs.tab_panel.getElementsByClassName('el-tabs__nav-next')[0];

        rightScrollArea.addEventListener('mousemove', e => {
          let speed = Math.abs(
            e.clientX - e.currentTarget.getBoundingClientRect().left
          );
          this.speedScroll =
            speed < this.minSpeedScroll ? this.minSpeedScroll : speed;
        });

        scrolling = setInterval(() => {
          if (
            tabsWrap.scrollLeft !== 0 &&
            Array.from(rightScrollArea.classList).includes('is-disabled')
          ) {
            rightScrollArea.classList.remove('is-disabled');
          }
          if (tabsWrap.scrollLeft !== 0 && this.leftScrolling) {
            tabsWrap.scroll({
              left: tabsWrap.scrollLeft - this.speedScroll,
              behavior: 'smooth'
            });
          } else {
            if (tabsWrap.scrollLeft === 0) {
              this.$refs.tab_panel
                .getElementsByClassName('el-tabs__nav-prev')[0]
                .classList.add('is-disabled');
            }
            clearInterval(scrolling);
          }
        }, 100);
      }
    },
    scrollRight() {
      let scrolling = null;
      if (this.rightScrolling) {
        let tabsWrap = this.$refs.tab_panel.getElementsByClassName(
          'el-tabs__nav-scroll'
        )[0];
        const leftScrollArea =
          this.$refs.tab_panel.getElementsByClassName('el-tabs__nav-prev')[0];

        leftScrollArea.addEventListener('mousemove', e => {
          const speed = Math.abs(
            e.clientX - e.currentTarget.getBoundingClientRect().right
          );
          this.speedScroll =
            speed < this.minSpeedScroll ? this.minSpeedScroll : speed;
        });
        scrolling = setInterval(() => {
          if (
            tabsWrap.scrollLeft != 0 &&
            Array.from(leftScrollArea.classList).includes('is-disabled')
          ) {
            leftScrollArea.classList.remove('is-disabled');
          }
          if (
            tabsWrap.scrollLeft != tabsWrap.scrollWidth &&
            this.rightScrolling
          ) {
            tabsWrap.scroll({
              left: tabsWrap.scrollLeft + this.speedScroll,
              behavior: 'smooth'
            });

            if (
              Math.floor(tabsWrap.scrollLeft) + 2 ===
                tabsWrap.scrollWidth - tabsWrap.parentNode.offsetWidth ||
              Math.floor(tabsWrap.scrollLeft) + 1 ===
                tabsWrap.scrollWidth - tabsWrap.parentNode.offsetWidth ||
              Math.floor(tabsWrap.scrollLeft) ===
                tabsWrap.scrollWidth - tabsWrap.parentNode.offsetWidth
            ) {
              this.$refs.tab_panel
                .getElementsByClassName('el-tabs__nav-next')[0]
                .classList.add('is-disabled');
            }
          } else {
            clearInterval(scrolling);
          }
        }, 100);
      }
    },
    updateLabels({ labels, module }) {
      //на странице вакансии в карточке отклика тоже есть субпанель
      //чтобы её не обновлять - проверям на используемый модуль

      //обернуто в интервал, чтобы гарантировать наличие рефа
      const interval = setInterval(() => {
        if (this.$refs['tab-text']) {
          if (module === this.module) {
            for (let i = 0; i < this.$refs['tab-text'].length; i++) {
              this.$refs['tab-text'][i].innerHTML = labels[i];
            }
          }
          clearInterval(interval);
        }
      }, 50);
    },
    clearCacheTabs() {
      //очистка данных о вкладках текущей панели вкладок,
      //но не в правой панели, там отдельная логика
      if (this.module != 'RightPanel') {
        const tabsData = this.getActiveTabData;
        for (let tab of this.tabs) {
          delete tabsData[tab.id];
        }
        store.commit('subpanels/setActiveSubpanelData', tabsData);
      }
    },
    beforeLeave() {
      return (
        !this.reloadTabCheck &&
        !(
          this.module == MODULE.CANDIDATES_MODULE &&
          store.state.subpanels.activeSubpanel[this.module].type ==
            'candidates_resume' &&
          !this.succesSave
        )
      );
    },
    async checkCommunication() {
      try {
        const resp = await getController({
          params: {
            module: 'Communications',
            action: 'count_messages',
            candidate_id: this.candidateId
          }
        });
        if (resp.data && resp.data.result) {
          this.communicationParams = {
            messagesCount: Number(resp.data.count) || 0,
            hasTelegram: !!resp.data.telegram, // проверка аккаунта телеги
            lastEmailId: resp.data.last_email_id, // последний id емейл-сообщ-я
            telegram: resp.data.user_telegram
          };
        }
      } catch (err) {
        this.catchError(
          err,
          'Возникла ошибка в экшне count_messages',
          'communications counter'
        );
      }
    },
    tabSubpanel(tab) {
      return tab?.intents[0]?.request?.request_params?.subpanel || '';
    },
    handleResize() {
      setTimeout(() => {
        let tabsWrap =
          this.$refs.tab_panel?.getElementsByClassName('el-tabs__nav-wrap')[0];

        if (tabsWrap) {
          this.tabsNeedScroll = Array.from(tabsWrap?.classList).includes(
            'is-scrollable'
          );

          if (this.tabsNeedScroll) {
            //если до этого листу с табами не был нужен скролл, то надо убрать обычный функционал зон для скролла
            tabsWrap.children[0].parentNode.replaceChild(
              tabsWrap.children[0].cloneNode(true),
              tabsWrap.children[0]
            );
            tabsWrap.children[1].parentNode.replaceChild(
              tabsWrap.children[1].cloneNode(true),
              tabsWrap.children[1]
            );
            //после чего задать свой
            if (!this.enabledLeftScroll) {
              tabsWrap.children[0].addEventListener(
                'mouseover',
                () => (this.leftScrolling = true)
              );
              tabsWrap.children[0].addEventListener(
                'mouseout',
                () => (this.leftScrolling = false)
              );
            }

            if (!this.enabledRightScroll) {
              tabsWrap.children[1].addEventListener(
                'mouseover',
                () => (this.rightScrolling = true)
              );
              tabsWrap.children[1].addEventListener(
                'mouseout',
                () => (this.rightScrolling = false)
              );
            }
          }
        }
      }, 0);
    },
    tabLoading(value) {
      store.commit('subpanels/setLoadingTab', {
        module: this.module,
        data: value
      });
    },
    reloadTab() {
      if (
        this.module !== MODULE.VACANCY_MODULE &&
        this.getActiveTab.id == 'communications'
      ) {
        this.communicationParams = {};
        // наличие сообщений в Коммуникациях
        this.checkCommunication();
      }
      if (store.state.candidate.changeableVacCandList.changeable) {
        store.commit('candidate/setChangeableVacCandListVisible');
      }
      store.dispatch('subpanels/getDataForTab', {
        module: this.module,
        tab: this.getActiveTab
      });
    },
    setTabNameText(tab) {
      return tab.count && Number(tab.count) > 0
        ? `${tab.label} (${tab.count})`
        : tab.label || tab.lbl?.value || 'Вкладка';
    },
    tabClick(tab, check = false) {
      if (
        this.module == MODULE.CANDIDATES_MODULE &&
        this.getActiveTab.type == 'candidates_resume' &&
        this.tabs[tab.index].type == 'candidates_resume' &&
        !check
      ) {
        store.commit('edit/setRecognisedForm', null);

        eventBus.$emit(EVENTBUS_EVENTS.SAVETAB, false, tab);
        if (tab.name == '1') {
          this.activeIdTab = this.getActiveTab.id;
        }
      } else {
        if (
          this.module !== MODULE.VACANCY_MODULE &&
          this.tabs[tab.index].id == 'communications'
        ) {
          // наличие сообщений в Коммуникациях
          this.checkCommunication();
        }

        if (
          this.module == MODULE.VACANCY_MODULE &&
          tab.id != 'candidates' &&
          (store.state.vacancy.currentVacancyCandidate ||
            localStorage.getItem('currentVacancyUserId'))
        ) {
          store.commit('vacancy/setParam', {
            name: 'currentVacancyCandidate',
            val: null
          });
          localStorage.removeItem('currentVacancyUserId');
        }
        store.commit('subpanels/setActiveSubpanel', {
          module: this.module,
          activeSubpanel: this.tabs[tab.index]
        });
        if (
          this.tabs[tab.index].name == 'candidate' ||
          this.tabs[tab.index].name == 'vacancy'
        ) {
          store.dispatch('rightPanel/getMetadata', {
            intentOrRequest: this.tabs[tab.index].intents.request
          });
          store.commit('rightPanel/setParam', {
            name: 'panelMode',
            val:
              this.tabs[tab.index].name == 'vacancy'
                ? 'vacancyPanel'
                : 'canditateStagePanel'
          });
        } else if (this.tabs[tab.index].id != 'duplicates') {
          if (store.state.candidate.changeableVacCandList.changeable) {
            store.commit('candidate/setChangeableVacCandListVisible');
          }
          //данные по вкладке грузяться только если они не были загружены ранее
          if (
            !store.state.subpanels.activeSubpanelData.hasOwnProperty(
              this.tabs[tab.index].id
            )
          ) {
            store.dispatch('subpanels/getDataForTab', {
              module: this.module,
              tab: this.tabs[tab.index]
            });
          }
        }
        //получение данных о фильтрации
        if (
          this.tabs[tab.index].name == 'candidates' ||
          this.tabs[tab.index].name == 'responds'
        ) {
          let module = this.tabs[tab.index].name;
          let filterData =
            store.state.subpanels.activeSubpanelData[module]?.custom_search;

          store.commit('subpanels/setFiltersData', {
            module: this.tabs[tab.index].name,
            data: filterData
          });
        }

        this.activeIdTab = this.tabs[tab.index].id;
      }

      if (
        this.module == MODULE.VACANCY_MODULE &&
        this.tabs[tab.index].name != 'candidates'
      ) {
        store.commit('rightPanel/setParam', {
          name: 'panelMode',
          val: null
        });
      }
    }
  },
  components: {
    OfferTab,
    VacanciesListTab,
    PublicatorTab,
    DescriptionTab,
    DocumentTab,
    HistoryTab,
    EventTab,
    RespondsTab,
    RespondsTableTab,
    AssessmentTab,
    CommunicationTab,
    CommentTab,
    Loader,
    ResumeTab,
    VacanciesTab,
    VacancySteps,
    ApplicationStagesTab,
    Picture,
    QuestionnairesTab,
    'el-tabs': Tabs,
    'el-tab-pane': TabPane,
    CandidatesTab,
    ResumeEditTab,
    ResumeListTab,
    DoublesTab,
    DoublesSubTab,
    RoleTab
  }
};
</script>

<style lang="scss" scoped>
.tab__panel {
  border-radius: 0 0 4px 4px;
}

.label {
  box-sizing: border-box;
  width: max-content;
}

.tabs {
  min-height: 231px;
  width: 100%;

  .tab__loading {
    display: flex;
    padding-top: 40px;
    justify-content: center;
  }

  & ::v-deep .el-icon-close {
    margin-left: 4px;
    height: 24px;
    width: 24px;
    cursor: pointer;

    &:hover {
      background: transparent;
    }

    &::before {
      content: url('../../../assets/img/delete.svg');
    }
  }

  & ::v-deep .el-tabs__new-tab {
    background: $blue8;
    height: 100%;
    width: unset;
    line-height: 18px;
    margin: 0;
    border: none;
    color: $blue64;
    border-radius: 4px;
    padding: 8px 16px;
    display: flex;
    gap: 4px;
    margin-left: 8px;

    & > .el-icon-plus {
      width: 24px;
      height: 24px;
      transform: none;
      content: url('../../../../src/assets/img/plus-blue.svg');
    }

    &::after {
      content: 'Добавить';
      height: 24px;
      align-self: center;
      -ms-grid-row-align: center;
      font-weight: 500;
      font-family: 'Roboto Medium';
      font-size: 16px;
      line-height: 24px;
    }

    .el-icon-plus::before {
      font-weight: 900;
      font-size: 24px;
      font-variant: normal;
      text-transform: none;
      line-height: 24px;
    }

    &:hover {
      background-color: $blue12;
    }
  }

  &--short {
    & ::v-deep .el-tab-pane {
      &:not(.tab-candidate) {
        height: calc(100vh - 241px) !important;
      }
    }
  }

  &--shadow {
    & ::v-deep .el-tab-pane {
      text-align: left;
      margin-top: 16px;
      border-radius: 4px;

      &:not(.tab-candidate) {
        background: $white;
        overflow-y: auto;
        border-radius: 4px;
      }
    }
  }

  &--no-shadow {
    & ::v-deep .el-tabs__header {
      box-shadow: none;
    }

    & ::v-deep .el-tab-pane {
      text-align: left;
      margin-top: 0;
      border-radius: 0 !important;
      -webkit-box-shadow: none !important;
      box-shadow: none !important;
      height: auto !important;
      min-height: 231px;
    }
  }
}

.el-tabs__item.is-active {
  .label {
    // & ::v-deep
    .tab-label {
      &__img {
        // background: yellow !important;
        filter: invert(48%) sepia(99%) saturate(4933%) hue-rotate(192deg)
          brightness(89%) contrast(101%);
      }
    }
  }
}

.tab-label {
  &__img {
    filter: invert(57%) sepia(10%) saturate(567%) hue-rotate(169deg)
      brightness(90%) contrast(85%);
  }
}
</style>
